import * as vp from 'vopay';
import { Box, Select, Button, DateRangePicker } from 'vopay';
import moment from 'moment';

import { FunctionComponent } from 'react';

import styles from './WebhooksHistory.module.scss';
import { useTranslation } from 'react-i18next';

type SearchFormProps = {
  shouldShowEndDateError: boolean;
  handleTimeRangeChange: (event: [vp.Timestamp, vp.Timestamp] | undefined) => void;
  setShouldShowEndDateError: (event: boolean) => void;
  eventType: string;
  handleTypeChange: (event: string) => void;
  payloadIDList: { [key: string]: string };
  getWebhooksList: () => void;
  payloadID: string;
  handlePayloadIDChange: (event: string) => void;
  webhooksHistorySearchError?: string;
  hasErrors: boolean;
};

type FC = FunctionComponent<SearchFormProps>;

const WebhooksHistorySearchForm: FC = (props: SearchFormProps) => {
  const { t } = useTranslation('translations', { keyPrefix: 'Settings.Webhooks.History' });
  const {
    shouldShowEndDateError,
    handleTimeRangeChange,
    setShouldShowEndDateError,
    eventType,
    handleTypeChange,
    payloadIDList,
    getWebhooksList,
    payloadID,
    handlePayloadIDChange,
    webhooksHistorySearchError,
    hasErrors,
  } = props;
  const initialTimeRange: [vp.Timestamp, vp.Timestamp] = [
    moment().subtract(1, 'month').valueOf() as vp.Timestamp,
    moment().valueOf() as vp.Timestamp,
  ];

  const eventTypes = [
    { value: 'All', label: t('eventAllOption') },
    { value: 'accountonboarding', label: t('eventAccountOnboardingOption') },
  ];

  return (
    <>
      <Box jc="sb" flx="col" width="100%" gap="md">
        <Box gap="sm" wrap="wrap">
          <div className={styles.datePickerContainer}>
            <DateRangePicker
              triggerVariant="outlineShadow"
              onChange={handleTimeRangeChange}
              initialTime={initialTimeRange}
              hasInvalidEndDate={false}
              shouldShowEndDateError={shouldShowEndDateError}
              setShouldShowEndDateError={setShouldShowEndDateError}
            />
          </div>
          <Box width="200px">
            <Select
              version="2"
              placeholder={t('eventPlaceholder')}
              options={eventTypes}
              name="type"
              value={eventType}
              onBlur={() => {}}
              onChange={(e) => {
                handleTypeChange(e.target.value);
              }}
              sort={false}
            />
          </Box>
          {Object.keys(payloadIDList).length > 0 && (
            <Box width="200px">
              <Select
                version="2"
                placeholder={t('payloadIDPlaceholder')}
                options={Object.entries(payloadIDList).map(([value, label]) => ({ value, label }))}
                name="PayloadID"
                value={payloadID}
                onBlur={() => {}}
                onChange={(e) => {
                  handlePayloadIDChange(e.target.value);
                }}
              />
            </Box>
          )}
          <Button
            id="search-transaction-history"
            label={t('searchButton')}
            width="110px"
            height="auto"
            borderRadius="10px"
            isDisabled={hasErrors}
            onClick={() => {
              getWebhooksList();
            }}
          />
        </Box>
        {webhooksHistorySearchError !== '' && (
          <div className={styles.webhookValidationError}>{webhooksHistorySearchError}</div>
        )}
      </Box>
    </>
  );
};

export default WebhooksHistorySearchForm;
